/*
 * This code was generated with assistance from GitHub Copilot.
 * De-bundled from react-dxd-components@0.1.33 compiled dist/index.js (webpack module id 7).
 */
import * as React from 'react';
import type { ReactNode } from 'react';
import classNames from './classnames-vendor';

export interface FieldProps {
  /** Disables input and grays it out */
  disabled?: boolean;
  /** Adds red styling to show that value is invalid */
  invalid?: boolean | string;
  /** String of additional class names to add; can be useful for setting the size of the element */
  className?: string | null;
  /** Content inside of the Field */
  children?: ReactNode;
}

const Field = ({ disabled = false, invalid = false, className = null, children = null }: FieldProps) => {
  const selectFieldClasses = classNames('Field', { 'is-disabled': disabled }, { 'is-invalid': invalid }, className);

  return <div className={selectFieldClasses}>{children}</div>;
};

export default Field;


